export default {
    // /////////////////////////////////////////////
    // SUITECASES
    // /////////////////////////////////////////////
    UPDATE_SUITECASES(state, payload) {
        state.suitCases = payload.map(item => Object.seal(item));
    },
}